import { LandingPageConfig } from 'rangeConfig/@types';
import knoxhultBgImg from '../../views/LandingPage/images/knoxhult_bg_img.png';
import knoxhultOpenDesign from '../../views/LandingPage/images/knoxhult_open_design.jpg';
import designFromScratch from '../../views/LandingPage/images/designFromScratch.jpg';
import singleWallBgImg from '../../views/LandingPage/images/singleWallBgImg.jpg';
import knoxhultGalleryConfig from './knoxhultGalleryConfig';

const knoxhultLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: knoxhultBgImg,
    titleTextColor: '#fff'
  },
  designFromScratch: {
    backgroundImgUrl: designFromScratch,
    backgroundColor: '#cac8c0'
  },
  openDesign: {
    backgroundImgUrl: knoxhultOpenDesign,
    backgroundColor: '#F5F5F5'
  },
  guide: {
    backgroundImg: singleWallBgImg,
    backgroundColor: '#D4C6AF'
  },
  browseInspiration: {
    galleryConfig: knoxhultGalleryConfig
  }
};

export default knoxhultLandingPageConfig;
